import { SystemDetails } from './systems';

export type SystemReviewRoleBack = 'GA' | 'RF' | 'RJ' | 'RT' | 'RDPD' | 'JS';

export type SystemReviewState = 'CORRECTION' | 'APPROVED';

export type SystemReviewStage = 'support' | 'reviewers' | 'chief';

export type SystemReviewRole =
  | 'apoyo_OGIA'
  | 'funcional_OGIA'
  | 'juridico_OGIA'
  | 'tecnico_OGIA'
  | 'dpd_OGIA'
  | 'jefe_servicio_OGIA';

export interface SystemReviewUserData {
  roles?: Record<string, string[]>;
}

export const systemReviewFieldKeys = [
  'systemType',
  'aiSystemProviderType',
  'aiProviderName',
  'aiModelName',
  'functionOfSystem',
  'otherFunctions',
  'description',
  'estimatedDeployDate',
  'dataType',
  'otherDataType',
  'estimatedFunctionalInputVolume',
  'administrationRole',
  'explainabilityLevel',
  'contractingImport',
  'contractValidity',
  'contractValidityDate',
  'annualAmount',
  'estimatedAnnualSavings',
  'systemClassification',
] as const;

export type SystemReviewFieldKey = (typeof systemReviewFieldKeys)[number];

export interface SystemReviewFieldPreviousReview {
  reviewers: string[];
}

export const systemReviewReviewerLabels: Record<string, string> = {
  RT: 'Revisor Tecnico',
  RJ: 'Revisor Juridico',
  RDPD: 'Revisor de Proteccion de Datos',
  RF: 'Revisor Funcional',
  GA: 'Grupo de Apoyo',
  JS: 'Jefe de Servicio',
};

export const systemReviewBackendSelectedRoleMap: Record<string, string> = {
  selectedSupportGroup: 'GA',
  selectedRevisorTecnico: 'RT',
  selectedRevisorJuridico: 'RJ',
  selectedRevisorFuncional: 'RF',
  selectedRevisorDpd: 'RDPD',
};

export interface SystemReviewDetailRequest {
  detail: 'system';
  id_sistema: string;
  role: SystemReviewRoleBack;
}

export interface SystemReviewPayload {
  idSistema: string;
  nombreSistema: string;
  userRole: SystemReviewRoleBack;
  state: SystemReviewState;
  comentario: string;
  camposSeleccionados: SystemReviewFieldKey[];
}

export interface SystemReviewDetail extends SystemDetails {
  functionOfSystem?: string[];
  otherFunctions?: string[];
  state?: string | null;
  orgCodeCreator?: string | null;
  codigo_organismo?: string | null;
  supportGroupState?: string | null;
  technicalReviewerState?: string | null;
  legalReviewerState?: string | null;
  functionalReviewerState?: string | null;
  dpdReviewerState?: string | null;
  serviceManagerState?: string | null;
  commentSupportGroup?: string | null;
  commentRevisorTecnico?: string | null;
  commentRevisorJuridico?: string | null;
  commentRevisorFuncional?: string | null;
  commentRevisorDpd?: string | null;
  commentServiceManager?: string | null;
}
